import { T_FAQ_PAGE_CONSTANTS } from './TYPES'

const DE_FAQ_PAGE_CONSTANTS: T_FAQ_PAGE_CONSTANTS = {
  PAGE_KICKER: 'HILF DIR SELBST MIT',
  PAGE_TITLE: 'Häufig gestellte Fragen',
  FAQ_CATEGORIES: [
    {
      categoryName: 'Allgemein',
      faqs: [
        {
          question: 'Was ist der Zweck dieser App?',
          answer:
            'Diese App wurde entwickelt, um Kinder auf spielerische und motivierende Weise zum Lesen zu ermutigen. Die Kinder, in der App als „Abenteurer“ bezeichnet, lesen Bücher offline und beantworten anschließend auf der Plattform Quizfragen zu den von ihnen gelesenen Büchern. Dadurch sammeln sie Punkte, die ihrer Maskottchenfigur Griffy - einem Greif - helfen, aufzusteigen und sich weiterzuentwickeln. So wird das Leseerlebnis noch unterhaltsamer und belohnender. Die App unterscheidet zwischen Kinder- und Erwachsenenkonten. Abenteurer können allein spielen, an Lese-Events oder Wettbewerben teilnehmen und über Freundschaftsanfragen Kontakt zu anderen aufnehmen. Sie können zudem die persönlichen Bibliotheken ihrer Freund*innen einsehen, was den Austausch von Büchern fördert und ein Gemeinschaftsgefühl rund ums Lesen schafft. Erwachsene Nutzer*innen können Quizze auf die Plattform hochladen und Lese-Events oder Wettbewerbe für die Abenteurer organisieren. Dieses kooperative System unterstützt sowohl angeleitetes als auch selbstständiges Lesen und macht die App zu einem vielseitigen Werkzeug, um eine lebenslange Liebe zu Büchern zu fördern.'
        },
        {
          question: 'Wer kann diese App nutzen?',
          answer:
            'Die App kann sowohl von Erwachsenen als auch von Kindern ("Abenteurern") genutzt werden.'
        },
        {
          question: 'Was kann ein Erwachsener auf der Plattform tun?',
          answer:
            'Erwachsene - Eltern, Lehrer - können Buch-Quizfragen hochladen, um die Bibliothek mit Bildungsinhalten zu erweitern. Erwachsene können auch Lese-Wettbewerbe und Events für eine Gruppe von Kindern erstellen, um das Lesen zu fördern und gleichzeitig deren Fortschritte und Erfolge zu verfolgen.'
        },
        {
          question: 'Was kann ein Kind auf der Plattform tun?',
          answer:
            'Kinder können Quizfragen beantworten, Bücher bewerten und verfolgen, ihre Bibliothek verwalten und sich mit Freunden austauschen. Außerdem können sie zwischen drei Spielweisen wählen: Solo-Abenteuer, Wettbewerbe auf Einladung und öffentliche Events.'
        },
        {
          question:
            'Wie kann ich ein Konto für mich und für mein(e) Kind(er) erstellen?',
          answer:
            'Sie können ein Konto erstellen, indem Sie Ihren vollständigen Namen, Ihr Geburtsdatum, Ihre bevorzugte Sprache, Ihre E-Mail-Adresse und ein aus 6 Ziffern bestehendes Passwort eingeben. Nachdem Ihr Konto eingerichtet wurde, können Sie über die Schaltfläche „Kind hinzufügen“ ein Konto für Ihr(e) Kind(er) erstellen, indem Sie  deren vollständigen Namen, Geburtsdatum, bevorzugte Sprache, Benutzername und ein aus 6 Ziffern bestehendes Passwort angeben.'
        }
      ]
    },
    {
      categoryName: 'Konto und Abonnement',
      faqs: [
        {
          question: 'Gibt es eine Abonnementgebühr?',
          answer:
            'Die Plattform ist für Erwachsene kostenlos, es fällt eine kleine Abonnementgebühr an, um die Plattform für ihre Kinder freizuschalten. Mehrere Abonnementpläne stehen zur Verfügung, je nach Anzahl der anzumeldenden Kinder und der gewünschten Abo-Dauer. Die Zahlung erfolgt über PayPal. Während der Beta-Testphase ist die Plattform kostenlos verfügbar.'
        },
        {
          question: 'Gibt es eine kostenlose Probezeit für Kinder?',
          answer:
            'Ja, es gibt eine 15-tägige Testphase für Kinder, nach der ein Erwachsener das Kind für einen Abonnementplan anmelden muss.'
        },
        {
          question: 'Welche Vorteile hat ein Abonnement?',
          answer:
            'Ein Abonnement schaltet die vollständigen Funktionen der Plattform frei, einschließlich der Teilnahme an Wettbewerben, der Anzeige von Bestenlisten und dem Erhalt von Abzeichen für Top-Platzierungen.'
        }
      ]
    },
    {
      categoryName: 'Spielweise und Funktionen',
      faqs: [
        {
          question: 'Was sind die Quizze?',
          answer:
            'Die Quizze sind Multiple-Choice-Tests, die darauf abzielen, das Verständnis des Textes eines offline gelesenen Buches zu überprüfen. Jedes Quiz besteht aus 5 Fragen, mit jeweils drei Antwortmöglichkeiten: eine richtige und zwei falsche. Punkte können durch die Auswahl der richtigen Antwort gesammelt werden (5 Punkte pro Frage, maximal 25 Punkte pro Quiz), die zur Erfahrung des Charakters beitragen und zu einem Aufleveln und einer Entwicklung seines/ihres Griffys führen.'
        },
        {
          question: 'Können Kinder an Wettbewerben gegeneinander teilnehmen?',
          answer:
            'Ja, Erwachsene können Wettbewerbe für Kinder erstellen, an denen sie teilnehmen können. Die Platzierungen werden auf der Bestenliste angezeigt und Abzeichen werden an die besten Platzierungen vergeben. Kinder können auch an Lese-Events teilnehmen, die vom Plattform veranstaltet werden.'
        },
        {
          question: 'Wie können Kinder sich auf der Plattform anfreunden?',
          answer:
            'Kinder können andere Kinder zu ihrer Freundesliste hinzufügen. Sie können auch die Bücher ihrer Freunde einsehen, um den Offline-Kontakt und Diskussionen zu erleichtern.'
        }
      ]
    },
    {
      categoryName: 'Bücher und Lesen',
      faqs: [
        {
          question:
            'Können Kinder in der App angeben, welche Bücher sie besitzen?',
          answer:
            'In der App können Kinder im Bereich „Meine Bibliothek“ die Bücher markieren, die ihnen zu Hause zur Verfügung stehen. So können ihre Freund*innen ebenfalls sehen, welche Bücher sie besitzen und sich darauf einigen, sich gegenseitig Bücher auszuleihen.'
        },
        {
          question: 'Können die Bücher in der App gelesen werden?',
          answer:
            'Nein, die App enthält keine Bücher, sondern nur die dazugehörigen Quizze. Die Kinder lesen die Bücher offline und beantworten anschließend die Quizfragen dazu in der App.'
        }
      ]
    },
    {
      categoryName: 'Technischer Support',
      faqs: [
        {
          question:
            'Ich habe meinen Benutzernamen vergessen. Was soll ich tun?',
          answer:
            'Sie können Ihren Benutzernamen erfahren, indem Sie auf der Anmeldeseite auf den Link "Benutzernamen vergessen" klicken und den Anweisungen folgen.'
        },
        {
          question: 'Ich habe mein Passwort vergessen. Was soll ich tun?',
          answer:
            'Sie können Ihr Passwort zurücksetzen, indem Sie auf der Anmeldeseite auf den Link "Passwort vergessen" klicken und den Anweisungen folgen.'
        },
        {
          question: 'Wie kontaktiere ich den Kundensupport?',
          answer:
            'Bei Problemen oder Fragen können Sie unser Kundensupport-Team über den Hilfebereich in der App oder per E-Mail an contact@griffyreads.com kontaktieren.'
        }
      ]
    }
  ]
}

export default DE_FAQ_PAGE_CONSTANTS
